import { render, staticRenderFns } from "./OrganisationMemberListSvg.vue?vue&type=template&id=c9eccce2&"
import script from "./OrganisationMemberListSvg.vue?vue&type=script&lang=ts&"
export * from "./OrganisationMemberListSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports